module.exports = __webpack_public_path__ + "img/dailypharm.ac64966.gif";